import { cn } from "../../utils";

interface CircularProgressBarProps {
  value: number;
  size?: number;
  strokeWidth?: number;
  className?: string;
}

export const CircularProgressBar: React.FC<CircularProgressBarProps> = ({
  value,
  size = 120,
  strokeWidth = 8,
  className,
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const strokeDasharray = circumference;
  const strokeDashoffset = circumference - (value / 100) * circumference;

  return (
    <svg
      width={size}
      height={size}
      className={cn("ui:-rotate-90 ui:transform", className)}
    >
      <circle
        r={radius}
        fill="none"
        cx={size / 2}
        cy={size / 2}
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={strokeWidth}
        strokeDasharray={strokeDasharray}
        strokeDashoffset={strokeDashoffset}
        className="ui:transition-all ui:ease-in-out"
      />
    </svg>
  );
};
